<div class="row">
    <div class="col-4">
        <div class="input-wrapper wide">
            <ValidatedDropDown [label]="'Title (optional)'" [options]="titleOptions" [selectedValue]="enrollment.title"
                (onValueChange)="updateInfo('title',$event)" [disabled]="disabled">
            </ValidatedDropDown>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <div class="input-wrapper">
            <ValidatedTextField label="First Name" [text]="this.enrollment.firstName"
                (onValueChange)="updateInfo('firstName',$event)" [validators]="[notBlankValidator]"
                [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-4">
        <div class="input-wrapper">
            <ValidatedTextField label="MI (optional)" [text]="this.enrollment?.middleInitial"
                (onValueChange)="updateInfo('middleInitial', $event)" [maxlength]="1" [validators]="[]"
                [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-6">
        <div class="input-wrapper">
            <ValidatedTextField label="Last Name" [text]="this.enrollment.lastName"
                (onValueChange)="updateInfo('lastName', $event)" [validators]="[notBlankValidator]"
                [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-4">
        <div class="input-wrapper">
            <ValidatedTextField label="Suffix (optional)" [text]="this.enrollment?.suffixName"
                (onValueChange)="updateInfo('suffixName', $event)" [validators]="[]" [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField label="Medicare Number" [text]="this.enrollment.medicareId"
                (onValueChange)="updateInfo('medicareId',$event)" (blur)="onHICNBlur()"
                [validators]="[notBlankValidator]" [maxlength]="20" [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper bottom-20">
            <label>Medicare Part A (Hospital) Effective date that appears on your Medicare Card (optional)</label>
            <JQDatePicker [selectedDate]="enrollment.medicarePartAEffectiveDate"
                (elementClicked)="updateInfo('medicarePartAEffectiveDate',$event)">
            </JQDatePicker>

            <!--<ValidatedDateTextField label="Medicare Part A (Hospital) (optional)"
                                    validationLabel="Effective date that appears on your Medicare Card (optional)"
                                    [date]="this.enrollment.medicarePartAEffectiveDate"
                                    (onDateChange)="updateInfo('medicarePartAEffectiveDate',$event)"
                                    [validators]="[]"
                                    [disabled]="disabled">
            </ValidatedDateTextField>-->
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper bottom-20">
            <label>Medicare Part B (Medical) Effective date that appears on your Medicare Card (optional)</label>
            <JQDatePicker [selectedDate]="enrollment.medicarePartBEffectiveDate"
                (elementClicked)="updateInfo('medicarePartBEffectiveDate',$event)">
            </JQDatePicker>
            <!--<ValidatedDateTextField label="Medicare Part B (Medical) (optional)"
                                    validationLabel="Effective date that appears on your Medicare Card (optional)"
                                    [date]="this.enrollment.medicarePartBEffectiveDate"
                                    (onDateChange)="updateInfo('medicarePartBEffectiveDate',$event)"
                                    [validators]="[]"
                                    [disabled]="disabled">
            </ValidatedDateTextField>-->
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <!--<label>Date of Birth (MM/DD/YYYY)</label>-->
            <!--<JQDatePicker [selectedDate]="enrollment.dateOfBirth"
                          (elementClicked)="updateInfo('dateOfBirth',$event)">
            </JQDatePicker>-->
            <ValidatedTextField label="Date of Birth (mm/dd/yyyy)" [text]="this.enrollment.dateOfBirth"
                (onValueChange)="updateInfo('dateOfBirth',$event)" [validators]="[notBlankValidator]"
                [disabled]="disabled">
            </ValidatedTextField>
            <span>Format as MM/DD/YYYY</span>
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper bottom-20">
            <ValidatedRadioButtonGroup [label]="'Sex'" [options]="genderOptions" [selectedValue]="enrollment.gender"
                [radioGroupName]="genderOptions" [disabled]="disabled" (onValueChange)="updateInfo('gender',$event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <MaskedValidatedTextField class="" [label]="'Phone Number (numbers only) (optional)'" id="phonenum"
                [text]="enrollment.primaryPhone" (onValueChange)="updateInfo('primaryPhone',$event)" [maxlength]="10"
                [inputMask]="phoneNumberInputMask" [validators]="[]">
            </MaskedValidatedTextField>
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <MaskedValidatedTextField class="" [label]="'Cell Phone Number (numbers only) (optional)'" id="cellnum"
                [text]="enrollment.cellPhone" (onValueChange)="updateInfo('cellPhone',$event)" [maxlength]="10"
                [inputMask]="phoneNumberInputMask" [validators]="[]" [disabled]="disabled">
            </MaskedValidatedTextField>
        </div>
    </div>
</div>
<!--<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField label="Email Address"
                                [text]="enrollment.email"
                                (onValueChange)="updateInfo('email',$event)"
                                [validators]="[notBlankValidator,emailAddressTextFieldValidator]"
                                [disabled]="disabled">
            </ValidatedTextField>
        </div>
    </div>
</div>-->